import { z } from 'zod';

export class EnvironmentConfig {
  version: string;
  backendUrl: string;
  configuratorUrl: string;
  production = false;
  build: { commit: string, number: string };
}

export function parseEnvironmentConfig(config: object): EnvironmentConfig {
  if ('configuration' in config) {
    config['production'] = config.configuration === 'production';
  }
  return RawEnvConfig.parse(config);
}

const RawEnvConfig = z.object({
  version: z.string(),
  backendUrl: z.string(),
  configuratorUrl: z.string(),
  production: z.boolean(),
  build: z.object({
    commit: z.string(),
    number: z.string(),
  }),
});
